export default __webpack_public_path__ + "static/media/add-to-svgrepo-com.3ae9a822.svg";